import { v4 as uuidv4 } from 'uuid';
import { ParameterNodeBuilder } from '../../builder/ParameterNodeBuilder';
import { LogicalType } from '../LogicalType';
import { Type } from '../Type';
export class ParameterObject extends Map {
    type = Type.Object;
    logicalType;
    tags;
    constructor(items = {}, logicalType, tags) {
        super(items instanceof Map ? items : Object.entries(items));
        this.logicalType = logicalType;
        this.tags = tags;
    }
    toJSON() {
        const entries = [...this.entries()].map(([k, v]) => [k, v.value]);
        return Object.fromEntries(entries);
    }
    static new() {
        return new ParameterObjectBuilder();
    }
}
export class ParameterObjectBuilder {
    logicalType;
    items = new Map();
    setLogicalType(logicalType) {
        this.logicalType =
            logicalType instanceof LogicalType
                ? logicalType
                : new LogicalType(logicalType, 1);
        return this;
    }
    addItem(key, value, build) {
        const builder = ParameterNodeBuilder.fromValue(uuidv4(), key, value);
        if (build)
            build(builder);
        const node = builder.build();
        this.items.set(key, node);
        return this;
    }
    addItems(items, build) {
        for (const [key, value] of items) {
            this.addItem(key, value, build);
        }
        return this;
    }
    build() {
        return new ParameterObject(this.items, this.logicalType);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGFyYW1ldGVyT2JqZWN0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi90eXBlcy9vYmplY3QvUGFyYW1ldGVyT2JqZWN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxFQUFFLElBQUksTUFBTSxFQUFFLE1BQU0sTUFBTSxDQUFBO0FBRW5DLE9BQU8sRUFBRSxvQkFBb0IsRUFBRSxNQUFNLG9DQUFvQyxDQUFBO0FBRXpFLE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQTtBQUM1QyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sU0FBUyxDQUFBO0FBRzlCLE1BQU0sT0FBTyxlQUNYLFNBQVEsR0FBNkI7SUFHNUIsSUFBSSxHQUFTLElBQUksQ0FBQyxNQUFNLENBQUE7SUFDeEIsV0FBVyxDQUFjO0lBQ3pCLElBQUksQ0FBVztJQUV4QixZQUNFLFFBRW9DLEVBQUUsRUFDdEMsV0FBeUIsRUFDekIsSUFBZTtRQUVmLEtBQUssQ0FBQyxLQUFLLFlBQVksR0FBRyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQTtRQUMzRCxJQUFJLENBQUMsV0FBVyxHQUFHLFdBQVcsQ0FBQTtRQUM5QixJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQTtJQUNsQixDQUFDO0lBRUQsTUFBTTtRQUNKLE1BQU0sT0FBTyxHQUFHLENBQUMsR0FBRyxJQUFJLENBQUMsT0FBTyxFQUFFLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUE7UUFDakUsT0FBTyxNQUFNLENBQUMsV0FBVyxDQUFDLE9BQU8sQ0FBQyxDQUFBO0lBQ3BDLENBQUM7SUFFRCxNQUFNLENBQUMsR0FBRztRQUdSLE9BQU8sSUFBSSxzQkFBc0IsRUFBSyxDQUFBO0lBQ3hDLENBQUM7Q0FDRjtBQUVELE1BQU0sT0FBTyxzQkFBc0I7SUFDdkIsV0FBVyxDQUFjO0lBQ3pCLEtBQUssR0FBa0MsSUFBSSxHQUFHLEVBQUUsQ0FBQTtJQUUxRCxjQUFjLENBQUMsV0FBaUM7UUFDOUMsSUFBSSxDQUFDLFdBQVc7WUFDZCxXQUFXLFlBQVksV0FBVztnQkFDaEMsQ0FBQyxDQUFDLFdBQVc7Z0JBQ2IsQ0FBQyxDQUFDLElBQUksV0FBVyxDQUFDLFdBQVcsRUFBRSxDQUFDLENBQUMsQ0FBQTtRQUNyQyxPQUFPLElBQUksQ0FBQTtJQUNiLENBQUM7SUFFRCxPQUFPLENBQ0wsR0FBVyxFQUNYLEtBQVEsRUFDUixLQUE0QztRQUU1QyxNQUFNLE9BQU8sR0FBRyxvQkFBb0IsQ0FBQyxTQUFTLENBQUMsTUFBTSxFQUFFLEVBQUUsR0FBRyxFQUFFLEtBQUssQ0FBQyxDQUFBO1FBQ3BFLElBQUksS0FBSztZQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQTtRQUN6QixNQUFNLElBQUksR0FBRyxPQUFPLENBQUMsS0FBSyxFQUFFLENBQUE7UUFDNUIsSUFBSSxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsR0FBRyxFQUFFLElBQUksQ0FBQyxDQUFBO1FBRXpCLE9BQU8sSUFBSSxDQUFBO0lBQ2IsQ0FBQztJQUVELFFBQVEsQ0FDTixLQUE0QixFQUM1QixLQUE0QztRQUU1QyxLQUFLLE1BQU0sQ0FBQyxHQUFHLEVBQUUsS0FBSyxDQUFDLElBQUksS0FBSyxFQUFFLENBQUM7WUFDakMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxHQUFHLEVBQUUsS0FBSyxFQUFFLEtBQUssQ0FBQyxDQUFBO1FBQ2pDLENBQUM7UUFDRCxPQUFPLElBQUksQ0FBQTtJQUNiLENBQUM7SUFFRCxLQUFLO1FBQ0gsT0FBTyxJQUFJLGVBQWUsQ0FBSSxJQUFJLENBQUMsS0FBSyxFQUFFLElBQUksQ0FBQyxXQUFXLENBQUMsQ0FBQTtJQUM3RCxDQUFDO0NBQ0YifQ==